window.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.Footer__Block .Footer__Title').forEach(function (title) {
    title.addEventListener('click', function () {
      if (window.innerWidth < 769) {
        var block = this.closest('.Footer__Block');

        if (block.classList.contains('open')) {
          block.querySelectorAll('.Linklist').forEach(function (linklist) {
            linklist.classList.add('hidden');
          });
          block.classList.remove('open');
        } else {
          document.querySelectorAll('.Footer__Block .Linklist').forEach(function (linklist) {
            linklist.classList.add('hidden');
          });
          document.querySelectorAll('.Footer__Block').forEach(function (footerBlock) {
            footerBlock.classList.remove('open');
          });
          block.querySelectorAll('.Linklist').forEach(function (linklist) {
            linklist.classList.remove('hidden');
          });
          block.classList.add('open');
        }
      }
    });
  });
});
